<template>
    <div class="container">
      <Head :showBorder="4" />
      <img class="contact1" src="../assets/contact1.jpg" alt="" />
      <img class="mapImg" src="../assets/mapImg.jpg" alt="" />
      <Bottom/>
    </div>
  </template>
  
  <script>
  import Head from "@/view/module/head.vue";
  import Bottom from "@/view/module/bottom.vue";
  export default {
    name: "index",
    data() {
      return {};
    },
    components: {
      Head,
      Bottom
    }
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .mapImg{
    width: 100%;
    /* height: 1030px; */
  }
    .contact1{
        width: 100%;
        /* height: 568px; */
    }
  </style>
  


// WEBPACK FOOTER //
// src/view/contact.vue